// 工作台api
import request from '@/utils/request2'

// 查询流程委托代理接口
export function getAgentList (data) {
  return request({
    url: "/api/workbench/getAgentList",
    method: "get",
    params: data
  })
}

// 新增流程委托代理接口
export function addAgent (data) {
  return request({
    url: "/api/workbench/addAgent",
    method: "post",
    data: data,
    headers: { "Content-Type": "multipart/form-data;charset=UTF-8" }
  });
}

// 修改流程委托代理接口
export function saveAgent (params) {
  return request({
    url: "/api/workbench/saveAgent",
    method: "get",
    params: params
  });
}

// 4.删除流程委托代理接口
export function deleteAgent (params) {
  return request({
    url: "/api/workbench/deleteAgent",
    method: "post",
    data: params,
    headers: { "Content-Type": "multipart/form-data;charset=UTF-8" }
  });
}

// 修改代理记录
export function saveAgentRecord (data) {
  return request({
    url: "/api/workbench/saveAgentRecord",
    method: "post",
    data: data,
    headers: { "Content-Type": "multipart/form-data;charset=UTF-8" }
  });
}

// 2.获取单个员工的通讯录卡片信息
export function getEmpAddressCard (params) {
  const { userid, empcode, empid } = params;
  return request({
    url: '/api/workbench/getEmpAddressCard',
    method: 'get',
    params: { userid, empcode, empid }
  })
}